import { OnboardingItemKey } from "../../../common/enums";
import { IOnboardingFlow } from "./onboardingTypes";
import { buildFlow } from "./allSteps";

// All steps available to the Employee_Manager role.
// Identical to tenant except HallTypes (requires Tenant-level permission).
// To add/remove a step, edit this list. Step content lives in allSteps.ts.
const managerStepIds: OnboardingItemKey[] = [
  OnboardingItemKey.GetToKnowPlanny,
  OnboardingItemKey.StudioProfile,
  OnboardingItemKey.StudioWizard,
  OnboardingItemKey.PlanTypes,
  OnboardingItemKey.CreatePlan,
  OnboardingItemKey.PlanWizard,
  // OnboardingItemKey.HallTypes excluded — Employee_Manager cannot manage halls (Tenant-only endpoint)
  OnboardingItemKey.ServiceTypes,
  OnboardingItemKey.ClassCategories,
  OnboardingItemKey.EmployeesList,
  OnboardingItemKey.EmployeeWizard,
  OnboardingItemKey.CreateEvent,
  OnboardingItemKey.EventWizard,
  OnboardingItemKey.EventWizardHybrid,
  OnboardingItemKey.ServiceWizardGuide,
  OnboardingItemKey.BlockedTimeGuide,
  OnboardingItemKey.FirstUser,
  OnboardingItemKey.UserAdd,
  OnboardingItemKey.UserProfile,
  OnboardingItemKey.DashboardKpis,
  OnboardingItemKey.Statistics,
  OnboardingItemKey.StatisticsDetail,
  OnboardingItemKey.Support,
  // Page Guides (hidden, component-driven)
  OnboardingItemKey.RefillCardGuide,
  OnboardingItemKey.RefillCardEmpty,
  OnboardingItemKey.InventoryGuide,
  OnboardingItemKey.InventoryOverviewGuide,
  OnboardingItemKey.InventoryTransfersGuide,
  OnboardingItemKey.CashdeskGuide,
  OnboardingItemKey.CashdeskEmpty,
  OnboardingItemKey.FamiliesGuide,
  OnboardingItemKey.BreakTypesGuide,
  OnboardingItemKey.GymVisitsGuide,
];

export const managerFlow: IOnboardingFlow = buildFlow(managerStepIds);
